import type { Theme } from "@mui/material";

export default (theme: Theme) => {
  const responsiveField = {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100%",
    },
  };

  return {
    section: {
      gap: "0.5rem",
      padding: "0 0 0 7rem",
      [theme.breakpoints.down("md")]: {
        gap: 0,
        padding: 0,
      },
    },

    item: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
        padding: 0,
      },
    },

    email: {
      ...responsiveField,
    },
    jobTitle: {
      ...responsiveField,
    },
    industry: {
      ...responsiveField,
    },
    role: {
      ...responsiveField,
    },
    interests: {
      ...responsiveField,
    },
    companyName: {
      ...responsiveField,
    },

    countryAndLanguage: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "1rem",
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
        gap: 0,
        padding: 0,
      },
    },
    country: {
      flex: 1,
      ...responsiveField,
    },
    language: {
      minWidth: 120,
      ...responsiveField,
    },
  };
};
